module.exports = __webpack_public_path__ + "static/20230619_237-885b39601ded8567420b7e82dae75892.jpg";